'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Icon } from '@/components/ui/icon';
import { Loading03Icon } from '@/components/ui/icon/glyphs';
import { useInfiniteScrollSentinel } from '@/hooks/ui/use-infinite-scroll-sentinel';
interface SocialFeedListProps {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
  isError?: boolean;
  'data-testid'?: string;
  children: ReactNode;
}

/**
 * Page-scroll list wrapper for the social leaderboard tabs. Unlike
 * `InfiniteList`, it adds NO bounded scroll container — the children render
 * inline so the podium and the feed share one page scroll. Pagination is driven
 * by a viewport-rooted sentinel (`useInfiniteScrollSentinel`, 200px rootMargin)
 * that fires `fetchNextPage` as the page nears the end of the list.
 */
export function SocialFeedList(t0) {
  const $ = _c(14);
  const {
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isError: t1,
    "data-testid": testId,
    children
  } = t0;
  const isError = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== fetchNextPage || $[1] !== hasNextPage || $[2] !== isError || $[3] !== isFetchingNextPage) {
    t2 = {
      hasNextPage,
      isFetchingNextPage,
      fetchNextPage,
      isError
    };
    $[0] = fetchNextPage;
    $[1] = hasNextPage;
    $[2] = isError;
    $[3] = isFetchingNextPage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const sentinelRef = useInfiniteScrollSentinel(t2);
  let t3;
  if ($[5] !== sentinelRef) {
    t3 = <div ref={sentinelRef} className="h-1" aria-hidden={true} />;
    $[5] = sentinelRef;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isFetchingNextPage) {
    t4 = isFetchingNextPage ? <div className="flex justify-center py-3"><Icon icon={Loading03Icon} className="size-5 animate-spin text-foreground-secondary motion-reduce:animate-none" /></div> : null;
    $[7] = isFetchingNextPage;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== t3 || $[11] !== t4 || $[12] !== testId) {
    t5 = <div data-testid={testId}>{children}{t3}{t4}</div>;
    $[9] = children;
    $[10] = t3;
    $[11] = t4;
    $[12] = testId;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}